import React from "react";
import { TERMS_VERSION } from "../../common/constants";

const RefundPolicy = () => {
  return (
    <div
      style={{
        backgroundColor: "#f5f7fb",
        minHeight: "100vh",
        padding: "60px 20px",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          backgroundColor: "#ffffff",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
          lineHeight: "1.8",
          color: "#333",
        }}
      >
        {/* Header */}
        <h1
          style={{
            marginBottom: "10px",
            fontSize: "2.2rem",
            fontWeight: "700",
            color: "#111",
          }}
        >
          Cancellation & Refund Policy
        </h1>

        <p style={{ color: "#666", marginBottom: "30px" }}>
          Speak Bold with KK • Version {TERMS_VERSION}
        </p>

        <p>
          Speak Bold with KK operates on a session-based purchase model.
          Users can purchase individual sessions and use them at their convenience.
          We do not offer monthly subscription plans.
        </p>

        {/* Section 1 */}
        <h2 style={sectionTitleStyle}>Session Purchases</h2>
        <p>
          When a user purchases sessions, they receive access to book and attend
          available learning sessions. Sessions must be booked in advance through
          the platform.
        </p>

        {/* Section 2 */}
        <h2 style={sectionTitleStyle}>No Refund for Missed Sessions</h2>
        <p>
          Once a session is successfully booked, it is considered confirmed.
          If a user fails to attend or join the session at the scheduled time,
          the session will be marked as consumed and no refund or replacement
          session will be provided.
        </p>

        {/* Section 3 */}
        <h2 style={sectionTitleStyle}>Host Cancellation Policy</h2>
        <p>
          If a session is cancelled by the host or due to a technical issue
          from our side, the session will be credited back to the user’s account.
          Please note that the original payment amount will not be refunded;
          instead, the session credit will be restored for future booking.
        </p>

        {/* Section 4 */}
        <h2 style={sectionTitleStyle}>Payment Disputes</h2>
        <p>
          All payments are processed securely through Razorpay. If you experience
          any payment-related issues, please contact us directly before raising
          a dispute so we can assist you promptly.
        </p>

        {/* Section 5 */}
        <h2 style={sectionTitleStyle}>Contact Us</h2>
        <p>
          For any questions regarding cancellations or session credits, you can reach us at:
        </p>

        <div
          style={{
            backgroundColor: "#f9fafc",
            padding: "20px",
            borderRadius: "8px",
            marginTop: "15px",
          }}
        >
          <p style={{ margin: "5px 0" }}>
            <strong>Email:</strong> support@speakboldwithkk.com
          </p>
        </div>

        {/* Footer */}
        <div
          style={{
            marginTop: "40px",
            paddingTop: "20px",
            borderTop: "1px solid #eee",
            fontSize: "0.9rem",
            color: "#888",
          }}
        >
          Last Updated: {new Date().getFullYear()} <br />
          © {new Date().getFullYear()} Speak Bold with KK. All rights reserved.
        </div>
      </div>
    </div>
  );
};

const sectionTitleStyle = {
  marginTop: "35px",
  fontSize: "1.4rem",
  fontWeight: "600",
  color: "#222",
};

export default RefundPolicy;
